import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgArrowDown } from "@digits-shared/components/SVGIcons/line/ArrowDown.svg"
import colors from "@digits-shared/themes/colors"
import fonts, { BodyText } from "@digits-shared/themes/typography"
import styled from "styled-components"

export const TableEl = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  // Collapsing table
  &.table-collapsed {
    thead tr:last-child:not(:first-child) {
      display: none;
    }

    tbody {
      display: none;
    }
  }
`

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  background: ${colors.white};
  z-index: 1;

  &.stuck {
    box-shadow: rgb(17, 17, 17) 0 10px 14px -16px;
  }
`

export const Tbody = styled.tbody`
  background: ${colors.white};
`

export const Tfoot = styled.tfoot`
  background: ${colors.white};
`

export const Tr = styled.tr`
  background-color: rgba(255, 255, 255, 0);
  transition:
    background-color 200ms ease-out,
    box-shadow 200ms ease-out;

  border-top: 1px solid ${colors.secondary10};
  border-bottom: 1px solid ${colors.secondary10};
  box-shadow: 0 0 12px 0 rgba(50, 73, 127, 0);

  thead > & {
    border-top: none;
    border-bottom: none;

    // adjust headers paddings when there are 2 (summary + column headers)
    &:first-child:not(:last-child) th {
      padding-top: 12px;
      padding-bottom: 12px;
    }
    &:last-child:not(:first-child) th {
      padding-top: 3px;
    }
  }

  tbody > &:hover,
  tbody > &:focus {
    background-color: ${colors.white};
    border-top-color: #e6e9f0;
    border-bottom-color: #e6e9f0;
    box-shadow: 0 0 12px 0 rgba(50, 73, 127, 0.15);
  }

  &.clickable {
    cursor: pointer;
  }

  &&&.selected {
    background-color: #7597e84d;
  }
`

export const Td = styled.td`
  ${fonts.scale.detail};
  color: ${colors.secondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  padding: 8px;

  text-align: left;
  &:first-child {
    padding-left: 16px;
  }
  &:last-child:not(:first-child) {
    text-align: right;
  }
  &:last-child {
    padding-right: 16px;
  }

  b {
    font-weight: ${fonts.weight.heavy};
  }
`

export const THSortArrow = styled(SvgArrowDown)`
  ${svgPathStyles(colors.secondary, 1.5)};
  height: 14px;
  width: 14px;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
  opacity: 0;
  margin-top: -7px;
  transform: translateY(3px) rotate(0);
  &.asc {
    transform: translateY(3px) rotate(180deg);
  }
`

export const ThSort = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 4px;
  margin: -4px;

  &.sorted {
    color: ${colors.secondary};
    font-weight: ${fonts.weight.heavy};

    ${THSortArrow} {
      opacity: 1;
    }
  }

  &:hover {
    color: ${colors.secondary};
    background: rgba(102, 135, 211, 0.11);

    &:not(.sorted) ${THSortArrow} {
      opacity: 0.5;
    }
  }
`

export const Th = styled.th`
  ${fonts.scale.label};
  color: ${colors.secondary50};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  padding: 12px 8px 8px;

  text-align: left;
  &:first-child {
    padding-left: 16px;
  }
  &:last-child:not(:first-child) {
    text-align: right;
  }
  &:last-child {
    padding-right: 16px;

    & > ${ThSort} {
      justify-content: flex-start;
      flex-direction: row-reverse;
    }
  }
`

export const CellText = styled(BodyText)`
  width: 100%;
  font-weight: ${fonts.weight.medium};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${colors.secondary};

  &[data-placeholder] {
    color: ${colors.secondary50};
  }
`
